import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
if (typeof document !== 'undefined') {
  const head = document.head;
  ['https://cdn.magicpatterns.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach(href => {
    const l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = href;
    l.crossOrigin = 'anonymous';
    head.insertBefore(l, head.firstChild);
  });
  // 2. Preload hero image with high priority — FIRST resource after preconnects
  const p = document.createElement('link');
  p.rel = 'preload';
  p.as = 'image';
  p.href = 'https://cdn.magicpatterns.com/uploads/cup8nvYsqX6U3HDxFAxEAw/mocap_final_100_citas-removebg-preview.webp';
  (p as any).fetchPriority = 'high';
  head.insertBefore(p, head.querySelector('link[rel="stylesheet"]') || head.firstChild);
  // 3. Inject minimal placeholder for instant FCP before React mounts
  const root = document.getElementById('root');
  if (root && !root.hasChildNodes()) {
    root.innerHTML = '<div style="min-height:100vh;background:#050b14;display:flex;align-items:center;justify-content:center"><div style="text-align:center;padding:2rem"><div style="color:#c084fc;font-size:0.75rem;letter-spacing:0.1em;margin-bottom:1rem">👨‍👩‍👧‍👦 PACK 100 CITAS</div><div style="width:2rem;height:2rem;border:3px solid rgba(168,85,247,0.3);border-top-color:#a855f7;border-radius:50%;animation:spin 1s linear infinite;margin:0 auto"></div><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div></div>';
  }
  // 4. Google Fonts — load only essential weights, non-blocking
  const f = document.createElement('link');
  f.rel = 'stylesheet';
  f.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Poppins:wght@700;800&display=optional';
  f.media = 'print';
  f.onload = function () {
    ;
    (this as HTMLLinkElement).media = 'all';
  };
  head.appendChild(f);
  // 5. Meta Pixel — deferred until idle
  if (!document.querySelector('[data-meta-pixel]')) {
    const load = () => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1578258419905247');fbq('track','PageView');`;
      document.head.appendChild(s);
    };
    typeof requestIdleCallback !== 'undefined' ? requestIdleCallback(load) : setTimeout(load, 3000);
  }
}
render(<App data-id="element-290" />, document.getElementById('root'));